import { render, staticRenderFns } from "./DynamicLayout.vue?vue&type=template&id=7246c1b9"
import script from "./DynamicLayout.vue?vue&type=script&lang=js"
export * from "./DynamicLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports